import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'
import ProductGalleryUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/ProductGallery/ProductGallery'
import AnalyticsContext from 'context/AnalyticsContext'
import React, { useContext, useEffect, useRef, useState } from 'react'
import SkeletonProductGallery from '@interflora/ui-components/build/components/SkeletonProductGallery/SkeletonProductGallery'
import { useRouter } from 'next/router'
import useStyles from '@interflora/ui-components/build/components/ProductGallery/ProductGallery.styles'
type Props = UIProps & {
  uiType?: string
  meta?: {
    deliveryId: string
  }
}

const ProductGallery = (props: Props) => {
  const router = useRouter()
  const { classes } = useStyles()
  const analytics = useContext(AnalyticsContext)
  const isCategoryPage = router?.asPath?.includes('/category')
  const [showSkeleton, setShowSkeleton] = useState<boolean>(isCategoryPage)
  const {
    meta: { deliveryId },
    uiType,
    products,
    linksAfter,
  } = props
  const keysRef = useRef<string>()

  useEffect(() => {
    const keys = products.map((product) => product.key).join(',')
    if (keys !== keysRef.current) {
      keysRef.current = keys
      analytics.viewProductList({ id: deliveryId, name: uiType, products })
    }
  }, [analytics, uiType, deliveryId, products])

  useLoaded(props)
  return (
    <div className={classes.productGallery}>
      {showSkeleton && (
        <SkeletonProductGallery
          productCount={products?.length > 3 ? 3 : products?.length}
          showLinks={linksAfter?.length > 0}
        />
      )}
      <ProductGalleryUI {...props} showSkeleton={showSkeleton} setShowSkeleton={setShowSkeleton} />
    </div>
  )
}

export default ProductGallery
